const { default: axios } = require("axios");
import chatClass from './chat';

const Opportunity = function () {

    let activeRoomName = null;
    let activeChatChannel = null;
    let isChatChannelReady = false;
    let isUnloadBound = false;
    let audioContext = null;

    const cardLoad = function () {
        $('.cardLoad').each(function () {
            let el = $(this);
            let url = el.data('url');

            axios.get(url)
                .then(function (response) {
                    let data = response.data;
                    if (data.error === false) {
                        
                        let result = data.result;
                        el.find('.card-body').html(result.html);

                        if ($('#kt_chat_content').length > 0) {
                            chat();
                            $('.select2').select2();
                        }

                    } else if (el.attr('id') === 'cardTickets') {
                        // Escopo DELIBERADO (nao remova o teste do id): cardLoad percorre
                        // $('.cardLoad') — 13 portadores / 6 ids — e chatOpen (CrmController:4087-4095)
                        // devolve error:true em estado de ROTINA ("Chat nao encontrado" em oportunidade
                        // sem canal). Um else global mudaria o texto de 5 cards fora desta demanda.
                        // Ver 04-dev-php/entrega-v03.md §4 (premissa O-6) e 02-design/spec-v01.md §4.4.
                        // O teste e pelo id, e nao pela classe crm-tickets-tab-content, porque o id
                        // ja existia (detail.blade.php:197, nova-detail.blade.php:237).
                        // Estado S8: caixa alert-light-danger com text-dark-75 obrigatorio
                        // (a cor do tema, #F64E60 sobre #FFE2E5, da 2,79:1 e reprova WCAG 1.4.3).
                        let box = $('<div class="px-5 px-lg-7 py-8"></div>');
                        let alertBox = $('<div class="alert alert-custom alert-light-danger m-0" role="alert"></div>');
                        alertBox.append('<div class="alert-icon"><i class="fas fa-exclamation-circle"></i></div>');

                        // data.message vem do microservico: TEXTO, nunca HTML. E o envelope de erro
                        // traz html:"" (e o do chatOpen nem tem a chave), entao nao se le result.html.
                        let alertText = $('<div class="alert-text text-dark-75"></div>');
                        alertText.append(document.createTextNode(data.message || 'Não foi possível carregar os tickets. Tente recarregar a página.'));

                        alertBox.append(alertText);
                        box.append(alertBox);
                        el.find('.card-body').empty().append(box);
                    }

                })
                .catch(function (error) {
                    el.find('.card-body').html('<div class="text-muted text-center p-20" title="'+error+'"><i class="fas fa-exclamation-circle"></i>Falha ao carregar</div>');
                });
        });
    }

    const chat = function(){
        KTLayoutChat.setup(KTUtil.getById('kt_chat_content'));
        enterChannel($('#kt_chat_content').data('room'));

        chatClass.callbackChat();

        $('.scroll').animate({
			scrollTop: $('.messages-chat-whats').height()
		}, 1000);
    }

    const getAudioContext = () => {
        if (!audioContext && typeof window !== 'undefined' && window.AudioContext) {
            audioContext = new window.AudioContext();
        }

        return audioContext;
    };

    const playNotificationAudio = () => {
        const context = getAudioContext();
        const audioNotification = document.getElementById('audio-notification');

        if (context && context.state === 'running' && audioNotification) {
            audioNotification.play().catch(() => { });
        }
    };

    const getChatDomRefs = () => {
        const chatContent = $('#kt_chat_content');
        const messagesContainer = chatContent.find('.messages');
        const scrollContainer = $('.scroll');
        const footer = chatContent.find('.card-footer');

        return {
            chatContent,
            messagesContainer,
            scrollContainer,
            footer,
        };
    };

    const scrollChatToBottom = (scrollContainer, messagesContainer) => {
        scrollContainer.animate({
            scrollTop: messagesContainer.height()
        }, 100);
    };

    const handleChatMessageSuccess = (result, messagesContainer, footer, scrollContainer) => {
        if (result.user_id === messagesContainer.data('user_id') && result.chat_channel_id === messagesContainer.data('chat_channel_id')) {
            messagesContainer.append(result.html);

            if (result.html_footer !== undefined && $('#content').length === 0) {
                footer.replaceWith(result.html_footer);
            }

            scrollChatToBottom(scrollContainer, messagesContainer);
            playNotificationAudio();
        }
    };

    const handleChatMessageUpdate = (result, messagesContainer, scrollContainer) => {
        $(result.target).replaceWith(result.html);
        scrollChatToBottom(scrollContainer, messagesContainer);

        if (result.error_json !== undefined && result.error_json !== '') {
            if (result.error_json.action !== undefined && result.error_json.action === 'sendFlow') {
                const classUtilitites = new UtilitiesUP();
                classUtilitites.showAlert(result.error_json.translated_error, 'Ok');
                location.reload();
            }
        }
    };

    const cleanupChatChannel = () => {
        if (activeChatChannel && typeof activeChatChannel.stopListening === 'function') {
            activeChatChannel.stopListening('ChatMessage');
        }

        if (activeRoomName && typeof Echo !== 'undefined' && typeof Echo.leave === 'function') {
            Echo.leave(activeRoomName);
        }

        activeRoomName = null;
        activeChatChannel = null;
        isChatChannelReady = false;
    };

    const bindUnloadCleanup = () => {
        if (typeof window === 'undefined' || isUnloadBound) {
            return;
        }

        window.addEventListener('beforeunload', destroyChatChannel);
        window.addEventListener('pagehide', destroyChatChannel);
        isUnloadBound = true;
    };

    const destroyChatChannel = () => {
        if (typeof window !== 'undefined' && isUnloadBound) {
            window.removeEventListener('beforeunload', destroyChatChannel);
            window.removeEventListener('pagehide', destroyChatChannel);
            isUnloadBound = false;
        }

        cleanupChatChannel();
    };

    const enterChannel = function (roomName) {
        if (!roomName || typeof Echo === 'undefined') {
            return;
        }

        if (isChatChannelReady && activeRoomName === roomName && activeChatChannel) {
            return;
        }

        cleanupChatChannel();
        bindUnloadCleanup();

        activeRoomName = roomName;
        activeChatChannel = Echo.private(roomName)
            .listen('ChatMessage', (response) => {
                let messageElement = 0;
                let transactionCode;

                if (response.transaction_code !== undefined && response.transaction_code !== null) {
                    transactionCode = response.transaction_code;
                    messageElement = $("#" + transactionCode).length;
                }

                const domRefs = getChatDomRefs();
                const isNewMessage = transactionCode === undefined || messageElement === 0;
                const url = domRefs.messagesContainer.data(isNewMessage ? 'format' : 'update-message');

                axios.post(url, response.chatMessage)
                    .then(function (responseAxios) {
                        const data = responseAxios.data;
                        const result = data.result;

                        if (data.error === false) {
                            if (isNewMessage) {
                                handleChatMessageSuccess(result, domRefs.messagesContainer, domRefs.footer, domRefs.scrollContainer);
                            } else {
                                handleChatMessageUpdate(result, domRefs.messagesContainer, domRefs.scrollContainer);
                            }
                        }
                    })
                    .catch(function (error) {
                        if (isNewMessage) {
                            const classUtilitites = new UtilitiesUP();
                            classUtilitites.showCommunicationError(error);
                            console.log(error);
                        }
                    });
            });

        isChatChannelReady = true;
    };

    const select2Multi = () => {

        // multi select
        $('.select2-multi').each(function(){
            $(this).select2({
                placeholder: $(this).attr('data-placeholder'),
            })            
        })

    }

    const tabSearchDetail = (el) => {

        let elm         = el;
        let showContent = elm.attr('data-content');

        $('.tab-content-search').removeClass('active');
        $("#"+showContent).addClass('active');

    }

    return {
        init: function () {
            if ($('.cardLoad').length > 0) {
                cardLoad();
            }
            if ($('.select2-multi').length > 0) {
                select2Multi();
            }
            if ($('.navi-col-link-change-search').length > 0) {
                $(document).on('click', '.navi-col-link-change-search', function () {
                    tabSearchDetail($(this));
                });
            }
        },

        destroy: function () {
            destroyChatChannel();
        }
    }

}();

export default Opportunity;